module.exports = "/images/flag_usa.png?2994ea3fa518bdbc1985d06727943d07";